import { useInfiniteQuery } from 'react-query';
import { PAGE_SIZE } from 'utils/constants';
import { DjangoListResponse, ArtificialProposalResponse } from 'v2/models';
import restFactory from 'v2/utils/restFactory';
import { infiniteArtificialProposalReponseKeys } from './query-keys';

type UseAllArtificialResponsesProps = {
  searchID: number;
};

type FetchInfiniteArtificialProposalResponsesProps = {
  pageParam: number;
  searchID: number;
};

async function fetchInfiniteArtificialProposalResponses({
  pageParam = 1,
  searchID,
}: FetchInfiniteArtificialProposalResponsesProps) {
  const response = await restFactory.get<
    DjangoListResponse<ArtificialProposalResponse>
  >('/dj/api/v1/artificial_proposal_response/', {
    page: pageParam,
    size: PAGE_SIZE,
    search: searchID,
    has_proposal_response: false,
  });

  return {
    ...response,
    prev: pageParam,
    next: response.next ? pageParam + 1 : undefined,
  };
}

export function useInfiniteArtificialProposalResponses({
  searchID,
}: UseAllArtificialResponsesProps) {
  return useInfiniteQuery(
    infiniteArtificialProposalReponseKeys.all,
    ({ pageParam = 1 }) =>
      fetchInfiniteArtificialProposalResponses({ pageParam, searchID }),
    {
      getNextPageParam: (lastPage) => lastPage.next,
    }
  );
}
